package top.wcpe.allincore.ui.runtime.internal.text

/** 匹配受限子集占位符：%% / %d / %f / %s / %.Nf。 */
private val TOKEN = Regex("%(?:%|d|f|s|\\.(\\d+)f)")

/** JS：手写受限子集（%f 默认 6 位小数对齐 Java；参数不足 / 类型不符抛 IAE）。 */
internal actual fun formatStringCompat(fmt: String, args: Array<Any?>): String {
    var i = 0
    val out = TOKEN.replace(fmt) { m ->
        if (m.value == "%%") return@replace "%"
        if (i >= args.size) throw IllegalArgumentException("format() 参数不足：$fmt")
        val arg = args[i++]
        when {
            m.value == "%d" -> {
                if (arg !is Number) throw IllegalArgumentException("%d 需要数值，实际 ${arg?.let { it::class.simpleName }}")
                arg.toLong().toString()
            }
            m.value == "%s" -> arg.toString()
            else -> {
                if (arg !is Number) throw IllegalArgumentException("%f 需要数值，实际 ${arg?.let { it::class.simpleName }}")
                val digits = m.groupValues[1].ifEmpty { "6" }.toInt()
                fixedDecimals(arg.toDouble(), digits)
            }
        }
    }
    return out
}

/** 定点小数（四舍五入远离零，对齐 Java %f 的 HALF_UP 行为）。 */
private fun fixedDecimals(v: Double, digits: Int): String {
    if (!v.isFinite()) return v.toString()
    val neg = v < 0
    var scale = 1.0
    repeat(digits) { scale *= 10.0 }
    val scaled = kotlin.math.floor(kotlin.math.abs(v) * scale + 0.5).toLong()
    val intPart = scaled / scale.toLong().coerceAtLeast(1)
    val fracPart = if (digits == 0) 0L else scaled % scale.toLong()
    val sign = if (neg) "-" else ""
    if (digits == 0) return "$sign$intPart"
    return "$sign$intPart." + fracPart.toString().padStart(digits, '0')
}
